'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('db-admin-edit', {
      url: '/db-admin/:collection/:id',
      template: '<db-admin-edit></db-admin-edit>',
      authenticate: 'suite-superadmin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/db/edit/db-admin-edit.routes.js